export default __webpack_public_path__ + "static/media/lesbian-couple.4e238d9e.png";